<template>
  <RevStepper
    :active-step
    :alternative-text-back="i18n(translations.previousPage)"
    :alternative-text-close="i18n(translations.stepperClose)"
    :alternative-text-completed="i18n(translations.stepperCompleted)"
    :alternative-text-current="i18n(translations.stepperCurrent)"
    has-back
    :steps
    @back="emit('back')"
  />
</template>

<script setup lang="ts">
import { defineProps } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevStepper } from '@ds/components/Stepper'

import translations from './Stepper.translations'

defineProps<{
  activeStep: 'cart' | 'addresses' | 'payment'
}>()

const emit = defineEmits(['back'])

const i18n = useI18n()

const steps = [
  {
    name: 'cart',
    label: i18n(translations.cartStep),
  },
  {
    name: 'addresses',
    label: i18n(translations.shippingStep),
  },
  {
    name: 'payment',
    label: i18n(translations.paymentStep),
  },
  {
    name: 'confirmation',
    label: i18n(translations.confirmationStep),
  },
]
</script>
